module.exports = __webpack_public_path__ + "static/assets/25365a729d97c1ef1cdd81e120e0fbf3.png";